import React from 'react';

export const MassachusettsInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">State of Massachusetts</p>
        <p className="eds-l-mar-bot-1">
            <strong>Small Business Recovery Loan Fund</strong> |&nbsp;
            <a
                href="https://www.empoweringsmallbusiness.org/what-we-offer/emergency-loan-funds/covid-19-loan-fund"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            This $10M fund will provide emergency capital up to $75,000 to
            Massachusetts-based businesses with under 50 full- and part-time
            employees, including nonprofits.
        </p>
    </div>
);
